import { BROWSER_LOAD_EVENT, BROWSER_DOM_CONTENT_LOADED_EVENT, BROWSER_UNLOAD_EVENT, BROWSER_RESPONSE, BROWSER_REQUEST, BROWSER_REDIRECT, BROWSER_TLS_SSL, BROWSER_CONNECT, BROWSER_DNS, BROWSER_CACHE, CACHE_REMOVE, CACHE_PUT, CACHE_GET } from '@sentry/conventions/op';

const PAGELOAD_SPAN_NAME_FALLBACK = "Pageload";
const NAVIGATION_SPAN_NAME_FALLBACK = "Navigation";
const DB_SPAN_NAME_FALLBACK = "Database operation";
const GEN_AI_AGENT_SPAN_NAME_FALLBACK = "Generative AI agent operation";
const GEN_AI_INFERENCE_SPAN_NAME_FALLBACK = "Generative AI model operation";
const GRAPHQL_SPAN_NAME_FALLBACK = "GraphQL Operation";
const HTTP_SPAN_NAME_FALLBACK = "HTTP";
const MESSAGING_SPAN_NAME_FALLBACK = "Messaging";
const MCP_SERVER_SPAN_NAME_FALLBACK = "MCP server operation";
const MCP_NOTIFICATION_SPAN_NAME_FALLBACK = "MCP notification";
const RESOURCE_SPAN_NAME_FALLBACK = "Resource";
const ROUTER_SPAN_NAME_FALLBACK = "Router";
const REQUEST_HANDLER_SPAN_NAME_FALLBACK = "Request handler";
const SERVERLESS_FUNCTION_SPAN_NAME_FALLBACK = "Serverless function execution";
const FUNCTION_SPAN_NAME_FALLBACK = "Function execution";
const UI_MOUNT_SPAN_NAME_FALLBACK = "Component mount";
const UI_UPDATE_SPAN_NAME_FALLBACK = "Component update";
const UI_RENDER_SPAN_NAME_FALLBACK = "Component render";
const UI_UNMOUNT_SPAN_NAME_FALLBACK = "Component unmount";
const UI_RESOLVE_SPAN_NAME_FALLBACK = "Component resolve";
const UI_TASK_SPAN_NAME_FALLBACK = "UI task";
const UI_LONG_TASK_SPAN_NAME_FALLBACK = "Main UI thread blocked";
const UI_ACTION_SPAN_NAME_FALLBACK = "UI action";
const UI_ACTION_CLICK_SPAN_NAME_FALLBACK = "Click";
const UI_INTERACTION_CLICK_SPAN_NAME_FALLBACK = "Click";
const UI_INTERACTION_HOVER_SPAN_NAME_FALLBACK = "Hover";
const UI_INTERACTION_DRAG_SPAN_NAME_FALLBACK = "Drag";
const UI_INTERACTION_PRESS_SPAN_NAME_FALLBACK = "Key press";
const UI_WEBVITAL_LCP_SPAN_NAME_FALLBACK = "Largest contentful paint";
const UI_WEBVITAL_CLS_SPAN_NAME_FALLBACK = "Layout shift";
const UI_SPAN_NAME_FALLBACK = "UI";
const CACHE_OPERATION_NAMES = {
  [CACHE_GET]: "get",
  [CACHE_PUT]: "put",
  [CACHE_REMOVE]: "remove"
};
const BROWSER_NAVIGATION_TIMING_SPAN_NAMES = {
  [BROWSER_CACHE]: "Cache lookup",
  [BROWSER_DNS]: "DNS lookup",
  [BROWSER_CONNECT]: "Connect",
  [BROWSER_TLS_SSL]: "TLS handshake",
  [BROWSER_REDIRECT]: "Redirect",
  [BROWSER_REQUEST]: "Request",
  [BROWSER_RESPONSE]: "Response",
  [BROWSER_UNLOAD_EVENT]: "Unload event",
  [BROWSER_DOM_CONTENT_LOADED_EVENT]: "DOMContentLoaded event",
  [BROWSER_LOAD_EVENT]: "Load event"
};

export { BROWSER_NAVIGATION_TIMING_SPAN_NAMES, CACHE_OPERATION_NAMES, DB_SPAN_NAME_FALLBACK, FUNCTION_SPAN_NAME_FALLBACK, GEN_AI_AGENT_SPAN_NAME_FALLBACK, GEN_AI_INFERENCE_SPAN_NAME_FALLBACK, GRAPHQL_SPAN_NAME_FALLBACK, HTTP_SPAN_NAME_FALLBACK, MCP_NOTIFICATION_SPAN_NAME_FALLBACK, MCP_SERVER_SPAN_NAME_FALLBACK, MESSAGING_SPAN_NAME_FALLBACK, NAVIGATION_SPAN_NAME_FALLBACK, PAGELOAD_SPAN_NAME_FALLBACK, REQUEST_HANDLER_SPAN_NAME_FALLBACK, RESOURCE_SPAN_NAME_FALLBACK, ROUTER_SPAN_NAME_FALLBACK, SERVERLESS_FUNCTION_SPAN_NAME_FALLBACK, UI_ACTION_CLICK_SPAN_NAME_FALLBACK, UI_ACTION_SPAN_NAME_FALLBACK, UI_INTERACTION_CLICK_SPAN_NAME_FALLBACK, UI_INTERACTION_DRAG_SPAN_NAME_FALLBACK, UI_INTERACTION_HOVER_SPAN_NAME_FALLBACK, UI_INTERACTION_PRESS_SPAN_NAME_FALLBACK, UI_LONG_TASK_SPAN_NAME_FALLBACK, UI_MOUNT_SPAN_NAME_FALLBACK, UI_RENDER_SPAN_NAME_FALLBACK, UI_RESOLVE_SPAN_NAME_FALLBACK, UI_SPAN_NAME_FALLBACK, UI_TASK_SPAN_NAME_FALLBACK, UI_UNMOUNT_SPAN_NAME_FALLBACK, UI_UPDATE_SPAN_NAME_FALLBACK, UI_WEBVITAL_CLS_SPAN_NAME_FALLBACK, UI_WEBVITAL_LCP_SPAN_NAME_FALLBACK };
//# sourceMappingURL=spanNames.js.map
